import React, { useContext, useState } from 'react'
import './index.scss'
import { ICONS, IconType } from '@Const/common'
import { Link } from 'react-router'
import { getStrRHStatus } from '@App/helpers/rightsholder-status-helpers'
import { getDateFromIso } from '@App/helpers/get-date-iso-6801'
import clsx from 'clsx'
import Button from '@Components/Buttons/Button'
import ModalPortal from '@Components/Popups/ModalPortal'
import { StoresContext } from '@App/contexts'
import DeleteSongwriterPopup from '@Components/Popups/DeleteSongwriterPopup'

interface AccountCardProps {
    name: string
    totalWorks: number
    id?: string
    isValidationStatusWrong: boolean
    teamMembers?: number
    validationStatus?: string
    updateDate?: string
    openPopup?(): void
    viewDetails?: boolean
    link: string
    icon: IconType
    blueImageFilter?: boolean
    countType: string
    deleteButton?: boolean
}

const AccountCard = (props: AccountCardProps) => {
    const {
        name,
        totalWorks,
        id,
        isValidationStatusWrong,
        teamMembers,
        validationStatus,
        updateDate,
        openPopup,
        viewDetails = true,
        link,
        icon,
        blueImageFilter,
        countType,
        deleteButton,
    } = props
    const { userStore } = useContext(StoresContext)
    const date = updateDate ? getDateFromIso(updateDate) : ''
    const [displayDeletePopup, setDisplayPopup] = useState<boolean>(false)

    return (
        <div className="account-card">
            <ModalPortal isOpen={displayDeletePopup}>
                <DeleteSongwriterPopup id={id} totalWorks={totalWorks} setDisplayPopup={setDisplayPopup} />
            </ModalPortal>
            <div className="head-block">
                <img className={clsx(blueImageFilter && 'filtered')} src={icon} alt="account" />
                {deleteButton && !userStore.isInternal && (
                    <Button
                        className="delete-songwriter-button"
                        mainColor
                        type="tertiary"
                        onClick={() => setDisplayPopup(true)}
                        onlyIcon
                        icon={ICONS.trashCan}
                    />
                )}
                {viewDetails &&
                    (isValidationStatusWrong ? (
                        <p onClick={openPopup}>View</p>
                    ) : (
                        <Link to={link} className="link bold view-link">
                            View
                        </Link>
                    ))}
            </div>
            <div className="info-block">
                <h5>{name}</h5>
                {teamMembers !== undefined && (
                    <p className="count">
                        <span className="bold">{teamMembers}</span> connected user accounts
                    </p>
                )}
                <p className="count">
                    <span className="bold">{totalWorks.toLocaleString()}</span> total {countType}
                </p>
            </div>
            {updateDate && validationStatus && (
                <div className="bottom-block">
                    <p className="small">Status: {getStrRHStatus(validationStatus)}</p>
                    <p className="small bold">{date}</p>
                </div>
            )}
        </div>
    )
}

export default AccountCard
